import { Pipe, PipeTransform } from '@angular/core';

import { IconName } from '@fortawesome/fontawesome-svg-core';

interface Extension {
    [index: string]: IconName;
}

@Pipe({
    standalone: true,
    name: 'fileExtensionIcon',
})
export class FileExtensionIconPipe implements PipeTransform {
    private MAPPING: Extension = {
        pdf: 'file-pdf',
        xls: 'file-excel',
        xlsx: 'file-excel',
        doc: 'file-word',
        docx: 'file-word',
        csv: 'file-csv',
        txt: 'file-alt',
    };

    private DEFAULT: IconName = 'file';

    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
    transform(value: string, ...args: any[]): IconName {
        if (this.MAPPING[value]) {
            return this.MAPPING[value];
        }
        return this.DEFAULT;
    }
}
